import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation, useParams } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { api } from "@/lib/api";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SiteSettingsProvider } from "@/context/SiteSettingsContext";
import { AppearanceProvider, useAppearance, themeVars } from "@/context/AppearanceContext";
import { Header } from "@/components/layout/Header";
import { BottomNav } from "@/components/layout/BottomNav";
import { TopupPage } from "@/pages/TopupPage";
import { Home } from "@/pages/Home";
import { TransaksiSaya } from "@/pages/TransaksiSaya";
import { BongkarPage } from "@/pages/BongkarPage";
import { AdminLogin } from "@/pages/AdminLogin";
import { AdminShell } from "@/pages/admin/AdminShell";
import { Maintenance } from "@/pages/Maintenance";
import { InfoPopup } from "@/components/member/InfoPopup";
import { LEGACY_SLUGS } from "@/lib/assets";

const LegacyRedirect = () => {
  const { legacy } = useParams();
  return <Navigate to={LEGACY_SLUGS[legacy] || "/"} replace />;
};

const AdminGate = () => {
  const { user, loading } = useAuth();
  if (loading)
    return <div className="grid min-h-[60vh] place-items-center text-sm text-zinc-500">Memuat…</div>;
  return user ? <AdminShell /> : <AdminLogin />;
};

const Shell = () => {
  const isAdmin = useLocation().pathname.startsWith("/admin");
  const [status, setStatus] = useState({ loading: true });
  const { theme } = useAppearance();

  useEffect(() => {
    Object.entries(themeVars(theme)).forEach(([k, v]) => document.documentElement.style.setProperty(k, v));
    document.body.classList.toggle("jp-member", !isAdmin);
  }, [theme, isAdmin]);

  useEffect(() => {
    let timer;
    const fetchStatus = async () => {
      try {
        const { data } = await api.get("/settings/status");
        setStatus({ loading: false, ...data });
      } catch {
        setStatus({ loading: false, maintenance_mode: false });
      }
    };
    fetchStatus();
    timer = setInterval(fetchStatus, 60_000);
    return () => clearInterval(timer);
  }, []);

  if (status.loading) {
    return (
      <div className="grid min-h-screen place-items-center text-sm text-zinc-500">
        Memuat JP STORE…
      </div>
    );
  }

  // Allow admin access even during maintenance so operator can disable it
  const path = typeof window !== "undefined" ? window.location.pathname : "/";
  if (status.maintenance_mode && !path.startsWith("/admin")) {
    return <Maintenance message={status.maintenance_message} />;
  }

  return (
    <div className="flex min-h-screen flex-col bg-black">
      {isAdmin ? null : <Header />}
      <div className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/transaksi" element={<TransaksiSaya />} />
          <Route path="/bongkar" element={<BongkarPage />} />
          <Route path="/admin/login" element={<Navigate to="/admin" replace />} />
          <Route path="/adminjp" element={<Navigate to="/admin" replace />} />
          <Route path="/admin" element={<AdminGate />} />
          <Route path="/admin/:menu" element={<AdminGate />} />
          <Route path="/topup/:slug" element={<TopupPage />} />
          <Route path="/:legacy" element={<LegacyRedirect />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
      {isAdmin ? null : <BottomNav />}
      {isAdmin ? null : <InfoPopup />}
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SiteSettingsProvider>
          <AppearanceProvider>
        <BrowserRouter>
          <Shell />
        </BrowserRouter>
          </AppearanceProvider>
        </SiteSettingsProvider>
      </AuthProvider>
      <Toaster
        position="top-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "#121217",
            border: "1px solid #27272a",
            color: "#fafafa",
          },
        }}
      />
    </div>
  );
}

export default App;
